import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'

export default defineNuxtPlugin(() => {
   const br = useBreakpoints(breakpointsTailwind)
   const isHydrated = ref(false)

   if (import.meta.client) {
      onNuxtReady(() => {
         isHydrated.value = true
      })
   }

   return {
      provide: {
         isBreakpoint: (
            breakpoint: keyof typeof breakpointsTailwind,
            type: 'greater' | 'smaller'
         ) => {
            if (type === 'greater') {
               return br.greater(breakpoint).value
            } else if (type === 'smaller') {
               return br.smallerOrEqual(breakpoint).value
            }
         },
      },
   }
})
